import { DatePicker as DatePickerComponent } from "antd"
import styled from "styled-components"

export const Datepicker = styled(DatePickerComponent)``;